<template>
	<div class="omapi-template-listing omapi-card__flex">
		<templates-template-card v-for="template in templates" :key="'template-' + template.id" :template="template" />
	</div>
</template>
<script>
export default {
	props: {
		title: {
			type: String,
			default: '',
		},
		templates: {
			type: Array,
			required: true,
		},
	},
};
</script>
